import Calendar from 'react-calendar';
import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Col } from '@/components/Col';
import { NextImageWithLoader } from '@/components/NextImageWithLoader';
import { Row as BasicRow } from '@/components/Row';
import { SectionHeader } from '@/components/SectionHeader';
import { theme } from '@/theme';

import { ReactComponent as ChevronSvg } from '@/assets/icons/chevron.svg';

export const CalendarStyled = styled(Calendar)`
  &.react-calendar {
    width: 400px;
    max-width: 100%;
    background: white;
    /* border: 1px solid #a0a096; */
    font-family:
      Open Sans,
      -apple-system,
      BlinkMacSystemFont,
      Segoe UI,
      Roboto,
      Oxygen-Sans,
      Ubuntu,
      Cantarell,
      Helvetica Neue,
      sans-serif !important;
    line-height: 1.125em;
  }

  .react-calendar--doubleView {
    width: 700px;
  }
  .react-calendar__tile {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
  .react-calendar__tile:not(:disabled):hover,
  .react-calendar__tile:focus-visible {
    background: ${theme.colors.primary};
    outline: 2px solid ${({ theme }) => theme.colors.black} !important;
    outline-offset: -2px;
  }
  .react-calendar__navigation__next2-button {
    display: none;
  }
  .react-calendar__navigation__prev2-button {
    display: none;
  }

  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }

  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: 0.5em;
  }

  &.react-calendar,
  &.react-calendar *,
  &.react-calendar *:before,
  &.react-calendar *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  &.react-calendar button {
    margin: 0;
    border: 0;
  }

  &.react-calendar button:enabled:hover {
    cursor: pointer;
  }

  &.react-calendar button:disabled:hover {
    cursor: not-allowed;
  }

  &.react-calendar button:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.black} !important;
    outline-offset: -2px;
    z-index: 1;
  }

  .react-calendar__navigation {
    display: flex;
    height: 38px;
    margin-bottom: 1em;
  }
  .react-calendar__navigation__arrow:not(:disabled) {
    color: ${({ theme }) => theme.colors.primary};
  }
  .react-calendar__navigation button {
    min-width: 44px;
    background: none;
  }

  .react-calendar__navigation button:disabled {
    background-color: #fff;
  }
  .react-calendar__navigation__label {
    overflow: hidden;
    pointer-events: none;
    font-weight: bold;
  }

  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:focus-visible {
    background-color: transparent;
    outline: 2px solid ${({ theme }) => theme.colors.black} !important;
    outline-offset: 2px;
  }

  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font: inherit;
    font-size: 0.75em;
    font-weight: bold;
  }

  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
  }
  .react-calendar__month-view__weekdays__weekday abbr {
    font-size: 14px;
    text-decoration: none;
  }

  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font: inherit;
    font-size: 0.75em;
    font-weight: bold;
  }

  .react-calendar__month-view__days__day--weekend {
    /* color: #d10000; */
  }

  .react-calendar__month-view__days__day--neighboringMonth {
    color: #757575;
  }

  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
  }

  .react-calendar__tile {
    max-width: 100%;
    padding: 10px 6.6667px;
    background: none;
    text-align: center;
    line-height: 16px;
    font: inherit;
    font-size: 0.833em;
    border-bottom: 1px solid #e1e1e1 !important;
    color: black;
    font-family: ${theme.fontFamilies.openSans};
  }

  .react-calendar__tile:disabled {
    background-color: #fafafa;
  }
  .react-calendar__navigation__prev-button {
    margin-left: 95px !important;
  }
  .react-calendar__navigation__prev-button:disabled {
    color: ${({ theme }) => theme.colors.primary} !important;
  }
  .react-calendar__navigation__prev-button:hover {
    background-color: transparent !important;
  }
  .react-calendar__navigation__next-button {
    font-size: 14px !important;
    margin-right: 95px !important;
  }
  .react-calendar__navigation__next-button:disabled {
    color: ${({ theme }) => theme.colors.primary} !important;
  }
  .react-calendar__navigation__next-button:hover {
    background-color: transparent !important;
  }

  .react-calendar__tile--now {
    background: ${({ theme }) => theme.colors.primary};
  }

  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus-visible {
    background: ${({ theme }) => theme.colors.primary};
  }

  /* .react-calendar__tile--hasActive {
    background: ${({ theme }) => theme.colors.primary};
} */

  /* .react-calendar__tile--hasActive:enabled:hover,
.react-calendar__tile--hasActive:enabled:focus {
    background: ${({ theme }) => theme.colors.primary};
}
 */
  .react-calendar__tile--active {
    background: ${({ theme }) => theme.colors.primary};
  }

  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus-visible {
    background: ${({ theme }) => theme.colors.primary} !important;
    outline: 2px solid ${({ theme }) => theme.colors.black} !important;
    outline-offset: -2px;
  }

  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: #e6e6e6;
  }
`;
export const AppointmentHeader = styled(SectionHeader)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(0)};
  `};
`;

export const FormWrapper = styled(Box)`
  ${({ theme }) => css`
    background-color: ${theme.colors.tertiaryLightGrey};
    padding-block: ${theme.spacing(4)};

    ${theme.media.md.down} {
      padding-inline: ${theme.spacing(2)};
    }
  `};
`;

export const Row = styled(BasicRow)`
  margin: 0 auto;
  max-width: 388px;
  ${({ theme }) => css`
    grid-gap: ${theme.spacing(2)};

    ${theme.media.md.up} {
      max-width: 388px;
    }
  `}
`;
export const RegionSelectionsRow = styled(BasicRow)<{
  showRegionSelections: boolean;
}>`
  margin: 0 auto;
  max-width: 388px;
  ${({ showRegionSelections, theme }) => css`
    height: ${showRegionSelections ? 'auto' : '0'};
    overflow: ${showRegionSelections ? 'none' : 'hidden'};
    grid-gap: ${theme.spacing(2)};
    ${theme.media.md.up} {
      max-width: 388px;
    }
  `}
`;
export const TextRow = styled(BasicRow)`
  margin: 0 auto;
  max-width: 388px;
  ${({ theme }) => css`
    grid-gap: ${theme.spacing(2)};

    ${theme.media.md.up} {
      max-width: 776px;
    }
  `}
`;
export const BookOpetionRow = styled(BasicRow)`
  margin: 0 auto;
  max-width: 388px;
  ${({ theme }) => css`
    grid-gap: ${theme.spacing(2)};

    ${theme.media.md.up} {
      max-width: 640px;
    }
  `}
`;

export const ImageBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const CalendarWrapper = styled(Box)`
  padding-top: 10px;
  padding: 0 auto;
  display: flex;
  justify-content: center;
  background: white;
`;
export const SameDayNoticeWrapper = styled(Box)`
  padding: 0 auto;
  display: flex;
  justify-content: center;
  background: ${({ theme }) => theme.colors.white};
`;
export const RecaptChaCol = styled(Col)`
  margin-top: 33px;
  margin-bottom: 16px;
`;
export const AppointmentButtonCol = styled(Col)`
  margin-bottom: 33px;
`;
export const InputRow = styled(Row)`
  margin-top: 21px;
`;
export const CheckBoxCol = styled(Col)`
  margin-top: 50px;
`;
export const LegalTextWrapper = styled(Box)`
  font-weight: ${theme.fontWeights.regular};
  font-family: ${theme.fontFamilies.openSans};
`;
export const OptinOptionsText = styled(Box)`
  & > a {
    font-weight: ${theme.fontWeights.semibold};
    color: ${theme.colors.primaryDark};
  }
`;
export const TextAreaCol = styled(Col)`
  margin-top: 16px;
`;
export const BannerImage = styled(NextImageWithLoader)`
  .next-image {
    width: 100%;

    border-style: none;
    max-width: 100%;

    bottom: 0;
    height: 100%;
    left: 0;
    object-fit: cover;
    position: absolute;
    right: 0;
    top: 0;
  }
  ${({ theme }) => css`
    height: 59vw;
    ${theme.media.md.up} {
      height: 21vw;
    }
  `}
`;
export const BannerImageContainer = styled(Box)`
  overflow: hidden;
  position: relative;
  ${({ theme }) => css`
    height: 59vw;
    ${theme.media.md.up} {
      height: 21vw;
    }
  `}
`;
export const BannerImageWapper = styled(Box)``;
export const BannerContent = styled(Box)`
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 2;
  ${({ theme }) => css`
    font-family: ${theme.colors.white};
  `}
  padding: 30px 20px 45px;
  position: absolute;
  bottom: 50%;
  transform: translateY(50%);
  pointer-events: inherit;
`;
export const BannerContentWrapper = styled(Box)`
  text-align: center;
  width: 100%;
`;
export const StoreName = styled.span`
  text-align: center;
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${theme.colors.white};
    font-size: ${theme.fontSizes.h1Mobile};
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.h1};
    }
  `}
  letter-spacing: 0;
  font-size: 40px;
  font-weight: bold;
  hyphens: auto;
  text-transform: uppercase;
`;
export const Chevron = styled(ChevronSvg)`
  width: 24px;
  fill: ${({ theme }) => theme.colors.primary};
  margin-left: -4px;
`;
export const ChangeStoreCtaWrapper = styled(Box)`
  margin-top: 15px;
  text-decoration: underline;
`;

export const GroupIconWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.lightGrey};
    padding-top: ${theme.spacing(2.5)};
    padding-bottom: ${theme.spacing(2.5)};
  `}
`;
export const BreadCrumbWapper = styled(Box)`
  ${({ theme }) => css`
    display: none;
    ${theme.media.md.up} {
      display: block;
      max-width: 1400px;
      margin-right: auto;
      margin-left: auto;
      padding-bottom: 10px;
      padding-right: 15px;
      padding-left: 15px;
    }
  `}
`;
